import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {
  BASEROUTE,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_MAIN_PAGE,
} from '../../../constants/urls';

import { ForgetPasswordWrapper } from './styles';
import './styles.css';
import { recoverPassword } from '../modules/actions';


class ForgetPassword extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    userLang: PropTypes.string.isRequired,
    literals: PropTypes.object.isRequired,
    showLoading: PropTypes.func.isRequired,
    app: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);


    this.state = {
      email: '',
      formValid: false,
      message: '',
    };
  }

  
  handleEmailChange = () => (event) => {
    this.setState({
      email: event.target.value,
    });
    this.setState({
      formValid: (event.target.value !== ''),
    });
  };

  
  handleResetPassword = () => {
    const { email } = this.state;

    this.sendRecoverEmail((error, data) => {
      if (!error) {
        this.setState({
          message: data.info,
          email: (data.success) ? '' : email,
        });
      }
    });
  };

  
  // handleNoEmailReceived = () => {
  //   this.setState({
  //     flagSent: false,
  //   });
  // };

  
  sendRecoverEmail = (callback) => {
    const { showLoading, userLang: lang } = this.props;
    const { email } = this.state;
    showLoading(true);
    recoverPassword({ email, lang })
      .then((data) => {
        if (callback && typeof callback === 'function') {
          callback(false, data);
        }
        showLoading(false);
      })
      .catch((error) => {
        if (callback && typeof callback === 'function') {
          callback(true, error);
        }
        showLoading(false);
      });
  };

  render() {
    const {
      literals,
      isAuthenticated,
      location,
      app,
    } = this.props;

    const {
      email,
      formValid,
      message,
    } = this.state;
    if (isAuthenticated) {
      const flagRedirect = location.state
                           && location.state.from !== BASEROUTE
                           && location.state.from !== ROUTE_LOGOUT;
      const redirectTo = (flagRedirect) ? location.state.from : ROUTE_MAIN_PAGE;

      return (
        <Redirect to={{
          pathname: redirectTo,
          state: location.state,
        }}
        />
      );
    }

    return (
      <ForgetPasswordWrapper className='ForgetPassword' app={app}>
        <Grid container spacing={0} className='ForgetPassword__panel'>
          <Grid item xs={12} sm={12} md={12} className='ForgetPassword__panel--left'>
            <div className='ForgetPassword__panel--left__content'>
              <div className='ForgetPassword__panel--left__content__header text-align-center'>
                <img className='logo' src={app.logo} alt='logo' />
                <h1 className='title'>
                  {literals.title}
                </h1>
              </div>
              <div className='ForgetPassword__panel--left__content__form'>
                <div>
                  <FormControl
                    fullWidth
                    className='form__field'
                  >
                    <InputLabel
                      htmlFor='adornment-email'
                      classes={{
                        root: 'form__field__label',
                      }}
                    >
                      {literals.userEmail}
                    </InputLabel>
                    <Input
                      id='adornment-email'
                      type='text'
                      autoComplete='email'
                      autoFocus
                      value={email}
                      onChange={this.handleEmailChange()}
                      variant='outlined'
                      inputProps={{
                        className: 'form__field__input',
                      }}
                    />
                  </FormControl>

                  {(message !== '') && (
                    <span className='error'>
                      {message}
                    </span>
                  )}

                  <Button
                    fullWidth
                    variant='contained'
                    color='primary'
                    className='btn-send'
                    disabled={!formValid}
                    onClick={this.handleResetPassword}
                  >
                    {literals.resetPasswordAction}
                  </Button>

                  <Link to={ROUTE_LOGIN} className='btn-go-back'>
                    {literals.goBack}
                  </Link>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </ForgetPasswordWrapper>
    );
  }
}

export default ForgetPassword;



// WEBPACK FOOTER //
// ./src/routes/ForgetPassword/components/index.jsx